import React, { useState } from 'react';
import { Box } from '@material-ui/core';
import FsRegisterInitialForm from 'ui-elements/forms/FsRegisterInitialForm';
import { FsRegisterInitialFormDataProps } from 'ui-elements/forms/FsRegisterInitialForm/FsRegisterInitialForm';
import FsBody from 'ui-elements/typography/FsBody';
import FsLink from 'ui-elements/links/FsLink';
import Routes from 'routes';
import { registerInitialStep as registerLocales } from 'globals/locales/registration';
import defaultLocales from 'globals/locales/default';
import {
  FsCounterBox,
  FsHello,
  FsHelloWrapperBox,
  FsCenterBoxLine,
  FsCenterBoxSubTitle,
  FsCenterBoxTitle,
} from 'ui-elements/center-box-elements/FsCenterBoxElements.style-elements';
import { WrapperBox } from './RegisterInitialStep.style-elements';
import { RegisterStepProps } from '../Steps.types';

interface RegisterInitialStepProps extends RegisterStepProps {
  onGoNext?: (props?: FsRegisterInitialFormDataProps) => void;
}

const RegisterInitialStep: React.FC<RegisterInitialStepProps> = ({
  stepIndex,
  stepsLength,
  onGoNext,
}) => {
  const [formDefaults] = useState<FsRegisterInitialFormDataProps>({
    email: '',
  });

  return (
    <WrapperBox>
      <FsHelloWrapperBox>
        <FsHello>{registerLocales.hello}</FsHello>
        <FsCounterBox>
          <i>{stepIndex}</i>/{stepsLength}
        </FsCounterBox>
      </FsHelloWrapperBox>
      <FsCenterBoxTitle>{registerLocales.title}</FsCenterBoxTitle>
      <FsCenterBoxSubTitle>{registerLocales.subTitle}</FsCenterBoxSubTitle>
      <FsCenterBoxLine />
      <Box marginTop={3}>
        <FsRegisterInitialForm {...formDefaults} onGoNext={onGoNext} />
      </Box>
      <Box marginTop={3}>
        <FsBody>
          {defaultLocales.logInQuestion}{' '}
          <FsLink to={Routes.LOGIN}>{defaultLocales.logIn}</FsLink>
        </FsBody>
      </Box>
    </WrapperBox>
  );
};

export default RegisterInitialStep;
